<template>
  <div id="app">
    <router-view ref="view" />
    <van-tabbar v-model="active"
                active-color="#ef4f16"
                inactive-color="#8f959d"
                v-if="menuList.length">
      <van-tabbar-item :icon="getIcon(menu)"
                       v-for="(menu, m) in menuList"
                       :key="m"
                       @click="goMenu(menu)">{{menu.name}}</van-tabbar-item>
      <!-- <van-tabbar-item v-for="(menu, m) in menuList"
                       :key="m">
        <template slot="icon">
          <span v-if="getMenuIcon(menu)" class="menu-icon" :style="{ maskImage: `url(${getMenuIcon(menu)})`, WebkitMaskImage: `url(${getMenuIcon(menu)})` }" :aria-label="menu.name"></span>
          <van-icon v-else :name="getIcon(menu)" />
        </template>
        {{menu.name}}
      </van-tabbar-item> -->
      <!-- home-o -->
      <!-- <van-tabbar-item icon="goods-collect-o">流量宝</van-tabbar-item>
      <van-tabbar-item icon="tv-o">官网</van-tabbar-item>
      <van-tabbar-item icon="apps-o">产品介绍</van-tabbar-item> -->
    </van-tabbar>
  </div>
</template>

<script>
import navHome from "./assets/images/nav-home.png"
import navCard from "./assets/images/nav-card.png"
import navOpportunity from "./assets/images/nav-opportunity.png"
import navGuoqi from "./assets/images/nav-guoqi.png"
import navMine from "./assets/images/nav-mine.png"

// 路由 name 与内置模块的对应关系
const routeModuleMap = {
  Home: 'home',
  card: 'card',
  mine: 'mine',
  flow: 'flow',
  opportunity: 'opportunity',
  guoqi: 'guoqi'
}

export default {
  data () {
    return {
      active: -1,
      form: {},
      menuList: []
    }
  },
  computed: {
  },
  created () {
    if (this.$route.query.tenantId) {
      localStorage.setItem("tenantId", this.$route.query.tenantId);
    }
  },
  mounted () {
    this.getMenuList()
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.$nextTick(() => {
          this.$refs.view.$emit("change")
          this.getMenuList()
          this.syncActiveMenu()
        });
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    getMenuIcon (menu) {
      if (!menu || menu.type !== 'module') {
        return ''
      }
      const iconMap = {
        home: navHome,
        card: navCard,
        opportunity: navOpportunity,
        guoqi: navGuoqi,
        mine: navMine,
        flow: navOpportunity
      }
      return iconMap[menu.module] || ''
    },
    getIcon (menu) {
      if (menu.type === 'module' && menu.module === 'home') {
        return 'home-o'
      } else if (menu.type === 'module' && menu.module === 'mine') {
        return 'user-o'
      } else if (menu.type === 'module' && menu.module === 'card') {
        return 'idcard'
      } else if (menu.type === 'module' && menu.module === 'flow') {
        return 'goods-collect-o'
      } else if (menu.type === 'module' && menu.module === 'opportunity') {
        return 'bag-o'
      } else if (menu.type === 'module' && menu.module === 'guoqi') {
        return 'bar-chart-o'
      } else if (menu.type === 'link') {
        return 'tv-o'
      } else if (menu.type === 'article') {
        return 'notes-o'
      }
    },
    goMenu (menu) {
      if (!menu) {
        return
      }
      if (menu.type === 'module') { // 内置模块
        if (routeModuleMap[this.$route.name] === menu.module) { // 已在当前页
          return
        }
        let businessCardId = localStorage.getItem("businessCardId")
        if (menu.module === 'home') { // 首页
          this.go("/?id=" + businessCardId)
        } else if (menu.module === 'card') {
          this.go("/card?id=" + businessCardId)
        } else if (menu.module === 'mine') { // 我的
          this.go("/mine")
        } else if (menu.module === 'flow') { // 流量宝
          this.go("/flow")
        } else if (menu.module === 'opportunity') {
          this.go("/opportunity")
        } else if (menu.module === 'guoqi') { // 国企 · 智能风控
          this.go("/guoqi")
        }
      } else if (menu.type === 'link' && menu.linkUrl) { // 跳转链接
        if (menu.linkUrl.indexOf("http") == -1) {
          window.location.href = "http://" + menu.linkUrl
        } else {
          window.location.href = menu.linkUrl
        }
      } else if (menu.type === 'article') { // 关联文章
        this.go(
          `/details?id=${localStorage.getItem("ladingPageId") || 0
          }&businessCardId=${localStorage.getItem("businessCardId")
          }&channelId=${localStorage.getItem("channelId") || 0
          }&articleId=${menu.articleId}`
        )
      }
    },
    go (path) {
      if (this.$route.fullPath === path) {
        return
      }
      let result = this.$router.push(path)
      if (result && result.catch) {
        result.catch(() => { })
      }
    },
    syncActiveMenu () {
      const currentModule = routeModuleMap[this.$route.name]
      if (!currentModule || !this.menuList.length) {
        return
      }
      const index = this.menuList.findIndex(menu => menu.type === 'module' && menu.module === currentModule)
      if (index === -1 || index === this.active) {
        return
      }
      this.active = index
    },
    createFallbackMenu () {
      return [
        { name: '资讯', module: 'home', type: 'module', children: [] },
        { name: '名片', module: 'card', type: 'module', children: [] },
        { name: '商机', module: 'opportunity', type: 'module', children: [] },
        { name: '国企', module: 'guoqi', type: 'module', children: [] },
        { name: '我的', module: 'mine', type: 'module', children: [] }
      ]
    },
    getMenuList () {
      if (this.menuList.length) {
        return
      }
      this.$api
        .post("/api/crm/businessCardMenu/treeListByCardId", {
          businessCardId: this.$route.query.id || localStorage.getItem("businessCardId")
        })
        .then((res) => {
          if (res && res.code === "C0000") {
            if (res.result && res.result.length) {
              this.menuList = (res.result || []).sort((a, b) => a.sort - b.sort)
            } else {
              this.menuList = this.createFallbackMenu()
            }
            this.syncActiveMenu()
          } else {
            this.menuList = this.createFallbackMenu()
            this.syncActiveMenu()
          }
        })
        .catch(() => {
          this.menuList = this.createFallbackMenu()
          this.syncActiveMenu()
        })
    },
  }
}
</script>

<style lang="less">
.skeleton {
  padding: 20px;
}
.van-toast__text {
  text-align: left;
}
#app {
  padding-bottom: 100px;
}
.van-tabbar {
  height: 100px;
  border-top: 1px solid #e9e6e1;
  background: #fffdfc;
  box-shadow: 0 -4px 18px rgba(20, 32, 51, 0.04);
}
.van-tabbar-item {
  color: #8f959d;
  font-size: 20px;
  transition: none !important;
  -webkit-transition: none !important;
}
.van-tabbar-item--active {
  color: #ef4f16;
  background: #fffdfc;
}
.van-tabbar-item__icon {
  margin-bottom: 6px;
  height: 44px;
  font-size: 30px;
  transition: none !important;
  -webkit-transition: none !important;
}
.van-tabbar-item__icon .menu-icon {
  display: block;
  width: 50px;
  height: 44px;
  background-color: currentColor;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  transition: none !important;
  -webkit-transition: none !important;
}
.content img {
  width: 100% !important;
}
</style>
